import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punemumbaicarhire() {



const cardData = {
  keyword: " Pune Mumbai Car Hire ",

"headingDescription": "SRS Cab Service offers Pune Mumbai Car Hire, providing a comfortable, reliable, and flexible travel solution for families, business travelers, and tourists. Our well-maintained cars, professional drivers, and timely pickups ensure a smooth journey from Pune to Mumbai. Ideal for airport transfers, business trips, city tours, and weekend getaways, SRS Cab Service delivers transparent pricing, easy booking, and 24/7 customer support for a convenient and stress-free travel experience.",
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Gateway of India is one of Mumbai’s most iconic landmarks overlooking the Arabian Sea. Travelers using Pune Mumbai Car Hire from SRS Cab Service often visit this historic monument for sightseeing and photography."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive is a famous seaside promenade known for its scenic beauty and sunset views. Visitors using SRS Cab Service often relax here and enjoy the panoramic city skyline."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves are UNESCO World Heritage rock-cut caves on an island near Mumbai. Travelers using SRS Cab Service often include this destination for its cultural and historical significance."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "This historic railway station is renowned for its Victorian Gothic architecture. Visitors using SRS Cab Service often admire its architectural grandeur and heritage value."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is a popular coastal destination in Mumbai known for its street food and sunset views. Travelers using SRS Cab Service often visit for leisure and relaxation."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is a famous temple dedicated to Lord Ganesha. Visitors using SRS Cab Service often seek blessings and experience spiritual serenity."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a revered mosque and tomb located on an islet in the Arabian Sea. Travelers using SRS Cab Service often visit for its spiritual significance and scenic location."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a popular shopping street in Mumbai. Travelers using SRS Cab Service often explore this area for shopping and cultural experiences."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a large green area offering wildlife and trekking experiences. Visitors using SRS Cab Service often enjoy nature and outdoor activities here."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "Bandra-Worli Sea Link is an iconic bridge connecting key areas of Mumbai. Travelers using SRS Cab Service often take this route for its scenic views and engineering marvel."
  }
],



services: [
{
name: "Mumbai Pune Car Rental Services",
description: "Mumbai Pune car rental services offer reliable travel between cities for business and leisure. Customers can book cars for flexible journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car rental services."
},
{
name: "Pune Mumbai Pune Car Rental",
description: "Pune Mumbai Pune car rental provides round trip travel solutions for customers. Users can book vehicles for return journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car rental services."
},
{
name: "Pune Mumbai Innova Rental",
description: "Pune Mumbai Innova rental offers spacious SUV travel for families and groups. Customers can enjoy comfortable seating and luggage space. Professional drivers ensure safe journeys. Ideal for long-distance travel. Transparent pricing ensures value. Travel easily with Innova rental services."
},
{
name: "Pune Mumbai SRS Cab Service",
description: "Pune Mumbai SRS cab service provides reliable transportation for intercity travel. Customers can book cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Mumbai Cab Hire",
description: "Pune to Mumbai cab hire offers flexible vehicle options for long-distance travel. Customers can hire cabs for comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Pune to Mumbai Drop Cab",
description: "Pune to Mumbai drop cab provides direct transportation for one-way journeys. Customers can book cabs for quick and convenient travel. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with drop cab services."
},
{
name: "Pune to Mumbai Private Cab",
description: "Pune to Mumbai private cab offers personalized travel experience for customers. Users can book private vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with private cab services."
},
{
name: "Pune to Mumbai Taxi Booking",
description: "Pune to Mumbai taxi booking provides quick and easy reservation options. Customers can book taxis online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily."
},
{
name: "Pune Mumbai Airport Car Rental",
description: "Pune Mumbai airport car rental offers convenient airport transfer services. Customers can book vehicles for timely pickup and drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport car rental services."
},
{
name: "Pune to Mumbai Darshan Cab",
description: "Pune to Mumbai darshan cab offers sightseeing travel for tourists. Customers can book cabs for Mumbai city tours. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with darshan cab services."
},
{
name: "Pune to Mumbai Car Rental",
description: "Pune to Mumbai car rental provides reliable transportation for intercity travel. Customers can rent cars for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car rental services."
},
{
name: "Pune to Mumbai Car Booking",
description: "Pune to Mumbai car booking offers easy reservation options for customers. Users can book vehicles online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your car easily."
},
{
name: "Pune to Mumbai Car on Rent",
description: "Pune to Mumbai car on rent offers flexible travel for long-distance journeys. Customers can rent vehicles for business and leisure trips. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car rental services."
},
{
name: "Pune to Mumbai Car Hire Charges",
description: "Pune to Mumbai car hire charges provide detailed pricing for travel planning. Customers can compare rates before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with car hire services."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab offers comfortable 7 seater travel for families. Customers can book vehicles for long-distance journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab provides spacious and comfortable SUV travel. Customers can enjoy premium seating and luggage space. Professional drivers ensure safe journeys. Ideal for family and corporate travel. Transparent pricing ensures value. Travel easily with Innova cab services."
},
{
name: "Pune Mumbai Car Rental",
description: "Pune Mumbai car rental offers convenient travel for intercity trips. Customers can rent vehicles for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car rental services."
},
{
name: "Pune to Mumbai Cab",
description: "Pune to Mumbai cab offers reliable transportation for business and personal travel. Customers can book cabs for comfortable journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "One Way Cab Pune to Mumbai",
description: "One way cab Pune to Mumbai offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Pune to Mumbai Cheapest Cab",
description: "Pune to Mumbai cheapest cab provides budget-friendly travel for intercity trips. Customers can book cabs at affordable prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with cheapest cab services."
},
{
name: "Pune to Mumbai Cab Fare",
description: "Pune to Mumbai cab fare provides estimated pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Pune to Mumbai Cab Charges",
description: "Pune to Mumbai cab charges offer detailed pricing for customers. Users can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab charge services."
},
{
name: "Pune to Mumbai Cab Price",
description: "Pune to Mumbai cab price provides cost details for travel planning. Customers can compare prices before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab price services."
},
{
name: "Pune to Mumbai Taxi One Way",
description: "Pune to Mumbai taxi one way offers convenient travel for single-direction trips. Customers can book taxis easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way taxi services."
},
{
name: "Pune to Mumbai Cab Booking",
description: "Pune to Mumbai cab booking offers quick reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily."
},
{
name: "Pune Mumbai Cabs",
description: "Pune Mumbai cabs provide reliable transportation for intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Mumbai Airport Drop Innova",
description: "Pune to Mumbai airport drop Innova offers premium SUV airport transfer services. Customers can enjoy spacious seating and comfort. Professional drivers ensure safe journeys. Ideal for airport travel. Transparent pricing ensures value. Travel easily with Innova airport services."
},
{
name: "Pune Mumbai Pune Cab",
description: "Pune Mumbai Pune cab offers round trip travel solutions for customers. Users can book cabs for return journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with round trip cab services."
},
{
name: "Pune to Mumbai Airport Cabs",
description: "Pune to Mumbai airport cabs provide reliable airport transfer services. Customers can book cabs for timely pickup and drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pune Mumbai Cab Hire",
description: "Pune Mumbai cab hire offers flexible vehicle options for long-distance travel. Customers can hire cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Pune to Mumbai Taxi Hire",
description: "Pune to Mumbai taxi hire provides convenient transportation for intercity travel. Customers can hire taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Pune Mumbai Car Booking",
description: "Pune Mumbai car booking offers easy reservation options for customers. Users can book vehicles online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your car easily."
},
{
name: "Pune Mumbai Car Hire Service",
description: "Pune Mumbai car hire service provides reliable travel solutions for intercity journeys. Customers can hire cars for business and personal use. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car hire services."
}
],

tableData: [
["Mumbai Pune Car Rental Services","Pune Mumbai Pune Car Rental"],
["Pune Mumbai Innova Rental","Pune Mumbai SRS Cab Service"],
["Pune to Mumbai Cab Hire","Pune to Mumbai Drop Cab"],
["Pune to Mumbai Private Cab","Pune to Mumbai Taxi Booking"],
["Pune Mumbai Airport Car Rental","Pune to Mumbai Darshan Cab"],
["Pune to Mumbai Car Rental","Pune to Mumbai Car Booking"],
["Pune to Mumbai Car on Rent","Pune to Mumbai Car Hire Charges"],
["Pune to Mumbai Ertiga Cab","Pune to Mumbai Innova Cab"],
["Pune Mumbai Car Rental","Pune to Mumbai Cab"],
["One Way Cab Pune to Mumbai","Pune to Mumbai Cheapest Cab"],
["Pune to Mumbai Cab Fare","Pune to Mumbai Cab Charges"],
["Pune to Mumbai Cab Price","Pune to Mumbai Taxi One Way"],
["Pune to Mumbai Cab Booking","Pune Mumbai Cabs"],
["Pune to Mumbai Airport Drop Innova","Pune Mumbai Pune Cab"],
["Pune to Mumbai Airport Cabs","Pune Mumbai Cab Hire"],
["Pune to Mumbai Taxi Hire","Pune Mumbai Car Booking"],
["Pune Mumbai Car Hire Service","Pune to Mumbai Car Hire Service"]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Pune Mumbai Car Hire Service",
    WhyChoosedescription: "SRS Cab Service offers dependable Pune Mumbai car hire for one-way and round-trip travel with smooth booking and professional service."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "We provide budget-friendly Pune to Mumbai car hire with clear pricing. Customers get full fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are well-experienced on the Mumbai-Pune Expressway, ensuring safe, fast, and comfortable travel between Pune and Mumbai."
  },
  {
    WhyChooseheading: "24/7 Car Hire Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune Mumbai car hire bookings, making it ideal for airport transfers, business trips, and emergency travel."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles ensuring a smooth and relaxing journey."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers based on your travel needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup & Drop",
    WhyChoosedescription: "We offer pickup from homes, hotels, offices, and Pune Airport with drop anywhere in Mumbai including airport, railway stations, and business hubs."
  },
  {
    WhyChooseheading: "Trusted Pune Mumbai Car Hire Provider",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune Mumbai car hire due to punctual service, professional drivers, and comfortable travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Pune Mumbai car hire service?", answer: "Yes, SRS Cab Service offers reliable car hire from Pune to Mumbai for one-way and round-trip travel." },
  { question: "How far is Mumbai from Pune?", answer: "The distance between Pune and Mumbai is approximately 150 km and takes around 3 to 4 hours via expressway." },
  { question: "Is Pune Mumbai car hire available 24 hours?", answer: "Yes, our service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Pune Mumbai travel?", answer: "We offer hatchbacks, sedans, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way car hire?", answer: "Yes, we provide both one-way and round-trip car hire services." },
  { question: "Do you provide Mumbai Airport drop?", answer: "Yes, we provide drop service to Mumbai Airport including T1 and T2 terminals." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book car hire online?", answer: "Yes, you can easily book Pune Mumbai car hire online or via phone." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from any location in Pune." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Sharma",
    feedback:
      "Booked Pune Mumbai car hire with SRS. Smooth ride and very professional driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Pooja Kulkarni",
    feedback:
      "Best Pune to Mumbai car hire service. Clean car and on-time pickup.",
    rating: 5
  }
];



























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune Mumbai Car Hire | SRS Cab Service",
  "description": "Affordable Pune to Mumbai car hire services including Innova, Ertiga, and private cabs. Book Pune to Mumbai taxi, one-way or round trip, for airport transfers, city travel, and darshan trips.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/pune-mumbai-car-hire",
  "areaServed": ["Pune", "Mumbai", "Mumbai Airport", "Thane", "Kalyan", "Vashi"],
  "openingHours": "Mo-Su 06:00-22:00",
  "priceRange": "₹₹",
  "serviceType": [
    "Pune Mumbai Car Hire",
    "Mumbai Pune Car Rental Services",
    "Pune Mumbai Innova Rental",
    "Pune to Mumbai Cab Hire",
    "Pune to Mumbai Drop Cab",
    "Pune to Mumbai Private Cab",
    "Pune to Mumbai Taxi Booking",
    "Pune to Mumbai Airport Car Rental",
    "Pune to Mumbai Darshan Cab",
    "Pune to Mumbai Ertiga Cab"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1380"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Pune Mumbai Car Hire | SRS Cab Service</title>
  <meta 
    name="description" 
    content="Book affordable Pune to Mumbai car hire services. Choose Innova, Ertiga, or private cabs for one-way or round trips, airport transfers, and city travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/60.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punemumbaicarhire;